<template>
    <div class="animated fadeIn gofixTab contractEquipmentTab assetManagement bgV2" v-bind:class="{'run-loading':loading}">
        <div class="boxShadow h-100 setBorderRadius">
            <div class="h-100">
                <b-row class="h-100">
                    <b-col md="12" class="h-100">
                        <gofix-card title="Update App Token" fullContent >
                            <template slot="gofixCard:right_header">
                                <div class="d-flex justify-content-end align-items-center">
                                    <gofix-button :disabled="!$checkRole($accessModule.app_token, 'create') && !$checkRole($accessModule.app_token, 'update')" label="Save" @click="autoSave" :loading="loadingSave"></gofix-button>
                                </div>
                            </template>
                            <b-row align-v="center">
                                <b-col md="8" offset="2">
                                    <gofix-form-input label="App Token LM" v-model="item.app_token_lm"></gofix-form-input>
                                </b-col>
                                <!-- <b-col md="5">
                                    <gofix-form-input label="App Token FM" v-model="item.app_token_fm"></gofix-form-input>
                                </b-col> -->
                            </b-row>
                        </gofix-card>
                    </b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    export default {
        name: 'app-token',
        data() {
            return {
                item: {
                    app_token_lm: null,
                    app_token_fm: null,
                },
                loading:false,
                loadingSave:false
            }
        },
        components: {

        },
        created() {
            global.axios(`/api/password-settings`, {
                method: "GET",
                headers: {
                    Accept: "application/json",
                }
            })
            .then(response => {
                if(response.data.data.app_token_lm){
                    this.item.app_token_lm = response.data.data.app_token_lm
                }
            })
            .catch(error => reject(error));
        },
        watch: {

        },
        computed: {
            ...mapGetters({
                
            })
        },
        methods: {
            async autoSave(){
                let request = {
                    app_token_lm: this.item.app_token_lm,
                    app_token_fm: this.item.app_token_fm,
                };
                
                this.loadingSave = true;
                this.$store.dispatch("AppTokenController/updateItem", request)
                .then(response => {
                    this.loadingSave = false;
                    this.$alertNotification("Update successfully!", "success");
                    
                })
                .catch(err => {
                    this.loadingSave = false;
                    console.log(err);
                })
            }
        },
    }
</script>